import axios from "axios";
import { BASE_URL } from "../config/config";

// otp
export const sendOTP = async ({ email }) => {
  return await axios.post(`${BASE_URL}/sendOtp`, { email });
};

// reset password
export const resetPassword = async (data) => {
  return await axios.post(`${BASE_URL}/forgetPassword`, data);
};

// user info
export const getUserProfile = async (token) => {
  const response = await axios.get(`${BASE_URL}/auth/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};